import { utils } from "../../../util/utils";
import { ContainerOptions } from "./configFiltro.model";
import { InputButtonConfig } from "./InputButtonConfig.model";
import { InputButtonSelectorConfig } from "./InputButtonSelectorConfig.model";
import { InputCheckboxFieldsConfig } from "./InputCheckboxFieldsConfig.model";
import { InputPeriodoConfig } from "./InputPeriodoConfig.model";
import { InputSelectConfig } from "./InputSelectConfig.model";
import { InputTextConfig } from "./InputTextConfig.model";

const DEFAULT_CONTAINER = {'column': true, 'is-3': true};

/**
 * Modelo de configuração do campo para o filtro
 * @class ConfigCampoFiltro
 * @namespace ConfigCampoFiltro
 */
 export class ConfigCampoFiltro {
    /**
     * Modelo do objeto de configuração do container do filtro
     * @param {Object} configuracoesDeCampo - Objeto de configurações do campo do formulário
     * @param {Object} configuracoesDeInput - Objeto de configurações para o input
     * @param {ContainerOptions} containerOptions = Objeto para configurações do container
     */
    constructor(configuracoesDeCampo = new configDeCampos(), configuracoesDeInput, containerOptions = new ContainerOptions({'column': true, 'is-3': true}, {})) {
      this.configuracoesDeCampo = configuracoesDeCampo;
      this.containerOptions = containerOptions;
      this.configuracoesDeInput = configuracoesDeInput? configuracoesDeInput : this.getConfiguracoesPadraoInput(this.configuracoesDeCampo)
    }

    getConfiguracoesPadraoInput(campo) {
        const input = this.getModeloInput(campo.type);
        input.id = utils.converterStringParaKebab(`${campo.id}-input-${campo.type}-${campo.key}`);
        input[campo.type == 'button'? 'nome' : 'label'] = campo.name;
        return input;
    }

    getModeloInput(type) {
        switch(type) {
            case 'periodo':
                return new InputPeriodoConfig();
            case 'select':
                return new InputSelectConfig();
            case 'checkbox-fields':
                return new InputCheckboxFieldsConfig();
            case 'button-selector':
                return new InputButtonSelectorConfig();
            case 'button':
                return new InputButtonConfig();
            case 'text':
            default:
                return new InputTextConfig();
        }
    }
  }

  export class configDeCampos {
    /**
     * Configuração de campos do filtro
     * @param {String} id - Id do campo
     * @param {String} type - tipo do campo
     * @param {String} name - nome do campo (para identificação)
     * @param {String} key - chave do item (usada como chave na query)
     * @param {Function | Null} formatter - função formatadora
     */
    constructor(id, type = 'text', name, key, formatter = null) {
        this.id = id;
        this.type = type;
        this.name = name;
        this.key = key;
        this.formatter = formatter
    }

  } 

  class ConfiguracoesDeContainer {

  }